import axios from 'axios';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import swal from 'sweetalert';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { BASEURL } from '../Config';
import { getUserData, getisAuthenticated, getSchool } from '../modules/reducers';

class MyStudents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            students: [],
            loading: true,
            editingId: null,
            editForm: {
                studentName: '',
                surname: '',
            },
            saving: false,
            errors: {},
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            window.location.href = 'login';
            return;
        }
        this.fetchStudents();
    }

    fetchStudents() {
        const { user, school } = this.props;
        const parentId = user.parentId;
        const schoolId = school._id;
        if (!parentId || !schoolId) {
            this.setState({ loading: false });
            return;
        }
        axios.get(`${BASEURL}/api/v1/student/getByParent/${parentId}/${schoolId}`)
            .then(res => {
                this.setState({ students: res.data || [], loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    startEdit(student) {
        this.setState({
            editingId: student._id,
            editForm: {
                studentName: student.studentName || '',
                surname: student.surname || '',
            },
            errors: {},
        });
    }

    cancelEdit() {
        this.setState({ editingId: null, editForm: {}, errors: {} });
    }

    handleEditChange(e) {
        const { name, value } = e.target;
        this.setState(prev => ({
            editForm: { ...prev.editForm, [name]: value },
        }));
    }

    async saveEdit(student) {
        const { editForm } = this.state;
        const errors = {};
        if (!editForm.studentName.trim()) errors.studentName = 'Student name is required';
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        this.setState({ saving: true });

        // Store old values in history before updating
        try {
            await axios.post(`${BASEURL}/api/v1/student/saveHistory`, {
                studentId: student._id,
                studentName: student.studentName,
                surname: student.surname,
                classId: student.classId,
                className: student.className,
            });
        } catch (err) {
            console.log('save student history error', err);
        }

        try {
            await axios.put(`${BASEURL}/api/v1/student/update`, {
                id: student._id,
                studentName: editForm.studentName.trim(),
                surname: editForm.surname.trim(),
            });
            swal('Success', 'Student details updated successfully.', 'success');
            this.setState({ editingId: null, saving: false, errors: {} });
            this.fetchStudents();
        } catch (err) {
            console.log('update student error', err);
            swal('Error', 'Failed to update student details. Please try again.', 'error');
            this.setState({ saving: false });
        }
    }

    render() {
        const { students, loading, editingId, editForm, saving, errors } = this.state;
        const schoolPath = `school/${this.props.school.slug || this.props.school.name}`;

        return (
            <div className="site-wrap">
                <Header page={'myStudents'} />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0">
                                <a href={schoolPath}>Home</a>
                                <span className="mx-2 mb-0">/</span>
                                <strong className="text-black">My Students</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="h3 mb-4 text-black">My Students</h2>
                                {loading ? (
                                    <p className="text-muted">Loading students...</p>
                                ) : students.length === 0 ? (
                                    <div className="alert alert-info">No students found for this account.</div>
                                ) : (
                                    students.map(student => (
                                        <div className="card mb-3" key={student._id}>
                                            <div className="card-body">
                                                {editingId === student._id ? (
                                                    <>
                                                        <h6 className="text-black mb-3 font-weight-bold">Edit Student</h6>
                                                        <div className="form-group row">
                                                            <div className="col-md-6">
                                                                <label className="text-black">
                                                                    Student Name <span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="studentName"
                                                                    value={editForm.studentName}
                                                                    onChange={e => this.handleEditChange(e)}
                                                                />
                                                                {errors.studentName && (
                                                                    <small className="text-danger">{errors.studentName}</small>
                                                                )}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="text-black">Surname</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="surname"
                                                                    value={editForm.surname}
                                                                    onChange={e => this.handleEditChange(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mt-2">
                                                            <button
                                                                className="btn btn-success mr-2"
                                                                onClick={() => this.saveEdit(student)}
                                                                disabled={saving}
                                                            >
                                                                {saving ? 'Saving...' : 'Save'}
                                                            </button>
                                                            <button
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.cancelEdit()}
                                                                disabled={saving}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="row align-items-center">
                                                        <div className="col-md-9">
                                                            <p className="mb-1">
                                                                <strong>Name: </strong>
                                                                <span className="text-primary">
                                                                    {student.studentName}{student.surname ? ` ${student.surname}` : ''}
                                                                </span>
                                                            </p>
                                                            <p className="mb-0">
                                                                <strong>Class: </strong>
                                                                <span className="text-primary">{student.className || '—'}</span>
                                                            </p>
                                                        </div>
                                                        <div className="col-md-3 text-right">
                                                            <button
                                                                className="btn btn-link p-0 text-primary"
                                                                onClick={() => this.startEdit(student)}
                                                                title="Edit"
                                                            >
                                                                <i className="fas fa-pencil-alt" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: getUserData(state),
    isAuthenticated: getisAuthenticated(state),
    school: getSchool(state),
});

export default compose(connect(mapStateToProps))(MyStudents);
